import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { LatestVideos } from './components/LatestVideos';
import { ShortsRow } from './components/ShortsRow';
import { RouteMap } from './components/RouteMap';
import { TopVideos } from './components/TopVideos';
import { Playlists } from './components/Playlists';
import { VideoArchive } from './components/VideoArchive';
import { AboutAuthor } from './components/AboutAuthor';
import { SubscribeBand } from './components/SubscribeBand';
import { FloatingSubscribe } from './components/FloatingSubscribe';
import { SiteFooter } from './components/SiteFooter';
import { playlists } from './data/playlists';
import { longForm, mappedVideos, shorts, topVideos } from './utils/videoLists';
const [featured, ...others] = longForm;
export function App() {
  return <div className="min-h-screen w-full bg-ink text-paper" data-id="element-0" data-mp="28s2xva27hvue">
      <SiteHeader data-id="element-1" data-mp="23ujk0b9f7l2z" />
      <main data-id="element-2" data-mp="23v2rsz5cwt3a">
        <Hero video={featured} data-id="element-3" data-mp="23t8ea5wf0398" />
        <LatestVideos videos={others.slice(0, 4)} data-id="element-4" data-mp="3ikh7o8icgqyg" />
        <ShortsRow shorts={shorts.slice(0, 12)} data-id="element-5" data-mp="3ijpcuzwkmx98" />
        <RouteMap videos={mappedVideos} data-id="element-6" data-mp="3ml12h5fg3ihf" />
        <TopVideos videos={topVideos.slice(0, 5)} data-id="element-7" data-mp="3mjzpgvevclx2" />
        <Playlists playlists={playlists} videos={longForm} data-id="element-8" data-mp="3rbra6pbcfxfa" />
        <VideoArchive videos={longForm} data-id="element-9" data-mp="3recd7hndojem" />
        <AboutAuthor data-id="element-10" data-mp="6hpnd64cbd2" />
        <SubscribeBand data-id="element-11" data-mp="4n4pyuukj8z" />
      </main>
      <SiteFooter data-id="element-12" data-mp="82ohezguggq" />
      <FloatingSubscribe data-id="element-13" data-mp="2zld1d7i6tbah" />
    </div>;
}